import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AppDetails } from '../../classes/application-details';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { ApplicationSummaryComponent } from '../application-summary/application-summary.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-multi-summary-wrapper',
    templateUrl: './multi-summary-wrapper.component.html',
    imports: [
        ApplicationSummaryComponent,
        MatProgressBarModule
    ]
})
export class MultiSummaryWrapperComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly route = inject(ActivatedRoute);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    user: UserInfo;
    apps: AppDetails[];

    ngOnInit() {
        this.user = this.userSvc.User;
        this.route.params
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((params) => {
                let scholarshipID = +params['id'];

                this.appSvc
                    .GetFinalistDetails(scholarshipID)
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe({
                        next: (res) => {
                            this.apps = res;
                        },
                        error: (error) => {
                            this.errorSvc.HandleServiceError(error);
                        }
                    });
            });
    }
}
